import React, { useContext } from 'react'
import { RendererContext } from '@/components/FURenderkit'
import { Button } from 'antd-mobile'
import { RESOURCE_MANAGER } from '@/config'
import { message } from 'antd'
import { AvatarContext } from '../RenderComp/Avatar'

const SaveAvatarBtn = (props) => {
    const { avatarTabRef } = props
    const { renderer } = useContext(RendererContext)
    const { avatar, avatarConfig } = useContext(AvatarContext)
    const saveCurrentAvatar = async () => {
        if (!avatar || !avatarConfig) return
        const gender = avatarConfig.data.gender
        const caseGender = gender.slice(0, 1).toUpperCase() + gender.slice(1).toLowerCase()
        await avatar.setAnimationAsync(
            `GAssets/animation/Asia${caseGender}/common/ani_ptag_a${gender}_huxi.bundle`
        );
        avatar.setRotate([0, 0, 0])
        const tmpCanvas = document.createElement("canvas")
        let parentNode = document.getElementById(
            "fu-renderkit-container"
        ) as HTMLElement
        tmpCanvas.style.width = "100%"
        tmpCanvas.style.height = "100%"
        tmpCanvas.style.position = "absolute"
        tmpCanvas.style.left = '0'
        tmpCanvas.style.top = '0'
        renderer?.captureImage(
            {
                width: 100,
                height: 175,
                quality: 2,
                tmpCanvas,
            },
            (nextSibling, done) => {
                parentNode.insertBefore(tmpCanvas, nextSibling)
                done((dataurl) => {
                    const avatarList = JSON.parse(window.localStorage.getItem('avatarList') || '[]')
                    const data = JSON.parse(avatar.getJson())
                    const config = {
                        avatar_id: avatarConfig.avatar_id,
                        data: data,
                        icon_full_url: dataurl,
                        icon_url: ''
                    }
                    const target = avatarList.find(i => i.avatar_id === avatarConfig.avatar_id)
                    if (target) {
                        target.data = data
                        target.icon_full_url = dataurl
                    } else {
                        config.avatar_id = `avatar${avatarList.length}`
                        avatarConfig.avatar_id = config.avatar_id
                        avatarList.push(config)
                    }
                    window.localStorage.setItem(
                        'avatarList',
                        JSON.stringify(avatarList)
                    )
                    parentNode.removeChild(tmpCanvas)
                    message.success('保存成功！');
                    RESOURCE_MANAGER.recorder.reset()
                    if (avatarTabRef && avatarTabRef.current) {
                        avatarTabRef.current.getStorageAvatarList()
                    }
                })
            }
        )
    }
    return (
        <Button
            {...props}
            onClick={saveCurrentAvatar}
        >
            保存
        </Button>
    )
}

export default SaveAvatarBtn
